module.exports = __webpack_public_path__ + "img/decoration-right.65e8748b.svg";